type TIconProps = {
    text: string | JSX.Element,
    color: "primary" | "warning" | "info"
}
export const Icon = ({ text, color }: TIconProps) => {

    return <div className={`alert alert-light admin-icon admin-icon-${color}`}>
        {text}
    </div>
}